import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminShippingRatesAPI } from '../services/api';
import './Users.css';

const ShippingRates = () => {
  const navigate = useNavigate();
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRates = async () => {
    setLoading(true);
    try {
      const ratesRes = await adminShippingRatesAPI.getAll();
      setRates(ratesRes.data?.shipping_rates || []);
    } catch (error) {
      toast.error('Error loading data: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRates();
  }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this shipping rate?')) return;
    try {
      await adminShippingRatesAPI.delete(id);
      toast.success('Shipping rate deleted');
      loadRates();
    } catch (error) {
      toast.error('Error deleting shipping rate: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading && rates.length === 0) {
    return <div className="loading">Loading shipping rates...</div>;
  }

  return (
    <div className="users-container">
      <div style={{ marginBottom: 20 }}>
        <button type="button" className="btn btn-primary" onClick={() => navigate('/shipping-rates/new')}>
          + Add shipping rate
        </button>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Country</th>
              <th>Label</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rates.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: 20 }}>
                  No shipping rates found
                </td>
              </tr>
            ) : (
              rates.map((r) => (
                <tr key={r.id}>
                  <td>
                    {r.country?.code || '—'} {r.country?.name ? `· ${r.country.name}` : ''}
                  </td>
                  <td>{r.label || '—'}</td>
                  <td>{r.amount}</td>
                  <td>{r.currency}</td>
                  <td>{r.is_active ? 'Active' : 'Inactive'}</td>
                  <td className="actions">
                    <button type="button" className="btn btn-primary" onClick={() => navigate(`/shipping-rates/${r.id}/edit`)}>
                      Edit
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => remove(r.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShippingRates;
